import { render, staticRenderFns } from "./Confirm.vue?vue&type=template&id=a7af2ede&scoped=true"
import script from "./Confirm.vue?vue&type=script&lang=ts"
export * from "./Confirm.vue?vue&type=script&lang=ts"
import style0 from "./Confirm.vue?vue&type=style&index=0&id=a7af2ede&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7af2ede",
  null
  
)

export default component.exports